import { TableRowDisplayEvent, Label, LookupModelSelectionEvent, TableRow, Textbox, ValidationResult, TableRowCreationEvent, TableRowModeChangeEvent, TableRowMode, DataSourceMode } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutMobileCommFilterJunctionInZoneTable } from "./autogen/AutogenLayoutMobileCommFilterJunctionInZoneTable";

export class MobileCommFilterJunctionInZoneTable extends AutogenLayoutMobileCommFilterJunctionInZoneTable {
    tableMCFilterJunctionInZoneOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = event.getTableRow().data as ModelRow;

        if (tableRow.mode === TableRowMode.QUICK_ADD) {
            const labelDescription = tableRow.findComponentById("labelDescription") as Label;
            labelDescription.marginTop = 12;
        }

    }

    async textboxInZoneOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const selectedRow = event.selection;
        if (selectedRow) {
            const tableRow = TableRow.getContainingTableRow(event.target);
            const textboxInZone: Textbox = tableRow.findComponentById("textboxInZone") as Textbox;

            textboxInZone.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                if (mode === DataSourceMode.SEARCH) {
                    return null;
                }
                const result: ValidationResult = {
                    component: textboxInZone,
                    isValid: true
                }

                let idExists = false;
                this.tableMCFilterJunctionInZone.rows.forEach(row =>  {
                    if (event.selection.get("id") === row.data.get("mc_object_id")) {
                        idExists = true;
                        result.isValid = false;
                        result.validationMessage = "Row already exists for this in zone";
                        return;
                    }
                });
                return result;
            };

            const labelDescription: Label = tableRow.findComponentById("labelDescription") as Label;
            labelDescription.text = event.selection.get("descr");
        }
    }

    tableMCFilterJunctionInZoneOnRowCreate(event: TableRowCreationEvent) {
        const tableRow = event.getTableRow();
        const modelRow = event.getTableRow().data as ModelRow;
        const lmData = modelRow.getLookupModelData("mc_object_id");

        if (lmData) {
            modelRow.set("zones.descr", lmData[0].get("descr"));
        }
    }
}
